import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "s-card control p-3 mb-3 container-list-inner" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "user-select" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-chevron-up"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-chevron-down"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IndexList = _resolveComponent("IndexList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
        return (_openBlock(), _createElementBlock("li", {
          key: user.id
        }, [
          _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["prevent"]),
            class: "is-uppercase",
            title: `List all of user '' strats`
          }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(user.last_name + ', ' + user.first_name), 1),
                _createElementVNode("span", _hoisted_4, [
                  (_ctx.selectedUser === user)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : (_openBlock(), _createElementBlock("i", _hoisted_6))
                ])
              ])
            ])
          ], 8, _hoisted_2),
          (_ctx.selectedUser === user)
            ? (_openBlock(), _createBlock(_component_IndexList, {
                key: 0,
                list: _ctx.list
              }, null, 8, ["list"]))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "is-divider" }, null, -1))
        ]))
      }), 128))
    ])
  ]))
}